<template>
  <div class="page stage-configurations">    
    <PageFull noOverlay fullWidth>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">              
                <div class="image"><img src="@/assets/images/bg_shape.jpg" alt=""></div>                          
                  <div class="page-content content">                    
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Event Production" h1="Stage Configurations" />                    
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">            
                          <p class="large">Allegiant Stadium’s vast open floor offers flexible staging configurations for any event. The various staging options maximize the usability of floor space and facilitate production versatility. Retractable seats provide a unique ability to increase floor length by approximately 56 feet, increasing 180&deg; sightlines. All configurations benefit from the intimate <span class="yellow">feel of an arena at the capacity of a stadium.</span></p>
                          <div class="stages">
                            <button @click="showModal = true; selectedImage = 'map_end-stage-map.jpg'"><img src="@/assets/images/event_production/map_end-stage-map.jpg" alt=""><div><RoundIcon icon="icon_close.svg" /><p>End Stage Map</p></div></button>
                            <button @click="showModal = true; selectedImage = 'map_240-stage-map.jpg'"><img src="@/assets/images/event_production/map_240-stage-map.jpg" alt=""><div><RoundIcon icon="icon_close.svg" /><p>240 Stage Map</p></div></button>
                            <button @click="showModal = true; selectedImage = 'map_360-stage.jpg'"><img src="@/assets/images/event_production/map_360-stage.jpg" alt=""><div><RoundIcon icon="icon_close.svg" /><p>360 Stage Map</p></div></button>
                          </div>
                      </div>                      
                    </transition>                    
                  </div>                
            </div>
        </div>
    </template>
    </PageFull>   
    <Modal v-show="showModal" @close="showModal = false"> 
        <template v-slot:content>
            <div class="slot-content">
                <img :src="require('@/assets/images/event_production/' + selectedImage)" alt="" class='modal-image'>
            </div>
        </template>
    </Modal>
  </div>
</template>

<script>
import TitleContent from "@/patterns/TitleContent.vue";
import PageFull from "@/patterns/PageFull.vue";
import RoundIcon from "@/patterns/RoundIcon.vue";
import Modal from "@/components/Modal.vue";
export default {
  name: "StageConfigurations",
  components: { TitleContent, PageFull, RoundIcon, Modal},
  data: () => ({
    scrollContent: false,  
    showModal:false,      
    selectedImage:'map_end-stage-map.jpg'
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss">
.stage-configurations {
    .modal-image {
        max-height: calc(100vh - 150px);
    }
    .slot-content {
        overflow: auto;
        max-width: 100%;          
    }
    .stages {
        display:flex;
    }
    button {
        flex-grow: 1;        
        background:none;
        padding:0;
        margin:0;        
        border:none;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.3);
        position: relative;
        overflow: hidden;
        outline:none;
        width: 100%;
        height:295px;
        max-height: calc(100vh - 550px);
        &:not(:last-child){
            margin-right:10px;
        }
        &:after {
          position: absolute;
          top:0;
          left:0;
          width:100%;
          height:100%;
          pointer-events: none;
          background-color: rgba(0,0,0,0.7);
          content: "";
        }
        img {
            width: 100%;
            height:100%;
            object-fit: cover;
            object-position: center;
        }
        p {
          color: #FFF;
          font-family: 'Gotham';
          font-size: 1em;
          font-weight: 900;
          letter-spacing: 0;
          line-height: 1;
          text-transform: uppercase;
        }
        .icon {
          margin:0 auto;
        }
        > div {
            text-align:center;
            position: absolute;
            z-index: 1;
            top:50%;
            left:50%;
            transform:translate(-50%, -50%);
        }
    }
}
</style>